import {
  Checkbox,
  FormControlLabel,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';

import { useFeatureFlags } from '@/contexts/useFeatureFlags';

export const SubnetSectionInfo = ({
  privateSubnetEnabled,
  onPrivateSubnetChange,
}: {
  privateSubnetEnabled: boolean;
  onPrivateSubnetChange: (checked: boolean) => void;
}) => {
  const { EnableCrossRegionOfflineRestore } = useFeatureFlags();

  return (
    <Stack gap='36px' className='w-[240px]'>
      <Typography className='font-semibold'>
        Subnets per availability zone
      </Typography>
      <Typography lineHeight={'20px'} fontWeight={300}>
        {EnableCrossRegionOfflineRestore
          ? // TODO: update with reference to documentation when ready
            `The restore server will be launched in the subnets you specify here. The subnets should be public or have VPC endpoints added.`
          : `The restore server will launch in the subnets you specify. Make sure outbound access is open in the selected subnets.`}
      </Typography>
      {EnableCrossRegionOfflineRestore && (
        <Tooltip
          title={
            <Stack gap='12px'>
              <Typography variant='body2' color='inherit'>
                To allow restoring to private subnets, Eon must use Multi-Region
                Access Points for the VPC.
              </Typography>
              <Typography variant='body2' color='inherit'>
                Turn this option on if any of the subnets in this VPC are
                private. If all subnets are public, you can leave it off.
              </Typography>
            </Stack>
          }
          placement='right'
          slotProps={{
            tooltip: {
              sx: {
                maxWidth: 350,
              },
            },
          }}
        >
          <FormControlLabel
            sx={{ ml: 0, alignItems: 'center' }}
            control={
              <Checkbox
                sx={{ p: 0, mr: 1 }}
                checked={privateSubnetEnabled}
                onChange={(e) => onPrivateSubnetChange(e.target.checked)}
              />
            }
            label={
              <Typography lineHeight={'20px'} fontWeight={300}>
                Allow restore to private subnets
              </Typography>
            }
          />
        </Tooltip>
      )}
    </Stack>
  );
};
